import MotionWrapper from '../../../layouts/MotionWrapper';
import TextArea from '../../../components/TextArea'
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import styles from './style.module.scss';
import { useState } from 'react';
import { useDispatch, useSelector } from '../../../store/store';
import { selectSendingSupportMessage } from '../../../store/workspace/selectors';
import { sendSupportMessageThunk } from '../../../store/workspace/thunks';
import { selectUserId } from '../../../store/auth/selectors';

export default function Support() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const sending = useSelector(selectSendingSupportMessage);

    const submit = async () => {
        try {
            await dispatch(sendSupportMessageThunk({
                userId,
                subject,
                message,
            }));

            setSubject('');
            setMessage('');
        } catch (e: unknown) {
            console.warn(e);
        }
    };

    return (
        <MotionWrapper className={styles.container}>
            <div className={styles.form}>
                <span className={styles.form_title}>Support</span>
                <p className={styles.form_description}>
                    We're here to help! Reach out to us with any questions or feedback.
                </p>
                <Input value={subject} onChange={setSubject} type='text' label='Subject' />
                <TextArea value={message} onChange={setMessage} label='Message' />
                <Button
                    text='Send'
                    type='Primary'
                    onClick={submit}
                    loading={sending}
                    className={styles.form_btn}
                    disabled={!subject || !message}
                />
            </div>
        </MotionWrapper>
    );
};
